/** 웰스토리몰 */
export const SITE_WELMALL = '1000000001';
/** 대한항공 */
export const SITE_SKYPASS = 'N2507000011';
/** 한미글로벌 */
export const SITE_HANMI = 'N2508000016';